var _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustryBarberHeroGradient80Ae653E174398Dce70477D0C308Dee8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1400,
    viewBox: "0 0 2000 1400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19456_95103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1111 405.425C1258 466.925 1517.02 432.079 1581.5 356.425C1740 170.454 1512 719.954 1512 719.954L1138.5 632.425C1138.5 632.425 1028.62 370.961 1111 405.425Z",
    fill: "#7F1DEB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_19456_95103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1163.13 382C985.681 355.924 596.667 453.5 524.5 516C290.5 769.5 727.474 1098.35 1163.13 1013C1648 918 1785.5 299.5 1631.13 281C1567 281 1502.34 380.545 1409.5 407.737C1316.66 434.928 1250.75 394.876 1163.13 382Z",
    fill: "url(#paint0_radial_19456_95103)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_19456_95103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 464.316,
    cy: 661.632,
    rx: 246.515,
    ry: 284.99,
    transform: "rotate(10.6434 464.316 661.632)",
    fill: "#FFCDDC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_19456_95103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 680,
    cy: 456,
    rx: 320,
    ry: 145,
    fill: "#FFCDDC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_19456_95103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 918,
    cy: 978,
    rx: 320,
    ry: 145,
    fill: "#841CF7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_19456_95103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.173,
    cy: 484.229,
    rx: 405.173,
    ry: 484.229,
    transform: "matrix(0.258819 0.965926 -0.949327 0.314289 1164.53 221.469)",
    fill: "#FF94EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19456_95103",
    x: 880.371,
    y: 118,
    width: 957.18,
    height: 801.954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_19456_95103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_19456_95103",
    x: 435.16,
    y: 257,
    width: 1280.21,
    height: 793.782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_19456_95103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_19456_95103",
    x: 36.3389,
    y: 197.825,
    width: 855.955,
    height: 927.614,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_19456_95103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_19456_95103",
    x: 180,
    y: 131,
    width: 1000,
    height: 650,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_19456_95103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_19456_95103",
    x: 418,
    y: 653,
    width: 1000,
    height: 650,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_19456_95103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_19456_95103",
    x: 158.101,
    y: 164.995,
    width: 1303.21,
    height: 1200.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_19456_95103"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19456_95103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(647 752) rotate(-22.7654) scale(1120.27 1120.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.319562,
    stopColor: "#841CF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789405,
    stopColor: "#841CF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryBarberHeroGradient80Ae653E174398Dce70477D0C308Dee8);
export default __webpack_public_path__ + "static/media/Industry_Barber_Hero_Gradient-80ae653e174398dce70477d0c308dee8.80ae653e174398dce70477d0c308dee8.svg";
export { ForwardRef as ReactComponent };